import {defineRule} from "vee-validate";
import {email, max, min, max_value, min_value, required} from "@vee-validate/rules";
import {isCreditCard} from "./index";

defineRule("required", required);
defineRule("email", email);
defineRule("min", min);
defineRule("max", max);
defineRule("max_value", max_value);
defineRule("min_value", min_value);
defineRule("max", max);

defineRule("participants", (val) => {
    return Object.values(val).reduce((total, value) => total + value, 0) ? true : "Please select at least one participant";

    //return (val.adults > 0 || val.seniors > 0 || val.children > 0 || val.infants > 0) ? true : "Please select at least one participant";
});

defineRule("participants_require_adult_or_senior", (val) => {
    // Normalize keys to lowercase for comparison
    const normalizedVal = {};
    Object.keys(val).forEach(key => {
        normalizedVal[key.toLowerCase()] = val[key];
    });

    if (!Object.hasOwn(normalizedVal, 'adult') &&
        !Object.hasOwn(normalizedVal, 'adults') &&
        !Object.hasOwn(normalizedVal, 'senior') &&
        !Object.hasOwn(normalizedVal, 'seniors')
    ) {
        // if these don't exist ... just bail
        return true;
    }

    // Check for adult variants
    const adultCount = normalizedVal.adult || normalizedVal.adults || 0;

    // Check for senior variants
    const seniorCount = normalizedVal.senior || normalizedVal.seniors || 0;

    return (adultCount > 0 || seniorCount > 0)
        ? true
        : "At least one Adult or Senior participant is required";
});

defineRule("credit_card", (val) => isCreditCard(val) ? true :  "Valid VISA or MasterCard required");
defineRule("at_least", (val, { total }, ctx) => val.length >= parseInt(total) ? true : `Please select at least ${total} ${ctx.field}`);
defineRule("at_minimum", (val, { total }, ctx) => val >= parseInt(total) ? true : `Please select at least ${total} ${ctx.field}`);
defineRule("month", (val, ctx) => parseInt(val) >= 1 && parseInt(val) <= 12  ? true : false);
defineRule("confirmations", (val, ctx) => !!val ? true : `Please confirm all the requirements for your booking`);

defineRule("not_empty", (val, {}, ctx) => {
    return val > 0 ? true : `Please select an ${ctx.field}`;
});

defineRule("date_required", (val, {}, ctx) => {
    return !isNaN(new Date(val)) ? true : `Please select a ${ctx.field}`;
});
defineRule("complete", (val, {}, ctx) => {
    return val?.complete ? true : `${ctx.field} not complete`;
});

defineRule("max_participants", (val, [max], ctx) => {
    if (max === false || max === "false") {
        return true;
    }

    return val.adults + val.seniors + val.infants + val.children <= max ? true : `There are only ${max} spots left at your selected time`;
});

defineRule("international_phone", (value, {}, ctx) => {
    // Check if value exists
    if (!value) {
        return `${ctx.field} is required`;
    }

    value = value.trim();
    value = value.replace(/\s+/g, '');


    // Regular expression for international phone numbers
    // Starts with +, followed by 1-3 digits (country code), then 4-14 digits
    const phoneRegex = /^\+[1-9]\d{0,2}\d{4,14}$/;

    if (!phoneRegex.test(value)) {
        return `${ctx.field} must be a valid phone number`;
    }

    return true;
});